/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SleepScheduleRequest
 */
export interface SleepScheduleRequest {
    /**
     * 
     * @type {number}
     * @memberof SleepScheduleRequest
     */
    regionId: number;
    /**
     * 
     * @type {number}
     * @memberof SleepScheduleRequest
     */
    totalDurationSeconds: number;
    /**
     * 
     * @type {Date}
     * @memberof SleepScheduleRequest
     */
    startTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SleepScheduleRequest
     */
    sleepStartHour?: number;
    /**
     * 
     * @type {number}
     * @memberof SleepScheduleRequest
     */
    sleepEndHour?: number;
    /**
     * 
     * @type {number}
     * @memberof SleepScheduleRequest
     */
    varianceMinutes?: number;
}

/**
 * Check if a given object implements the SleepScheduleRequest interface.
 */
export function instanceOfSleepScheduleRequest(value: object): value is SleepScheduleRequest {
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('totalDurationSeconds' in value) || value['totalDurationSeconds'] === undefined) return false;
    return true;
}

export function SleepScheduleRequestFromJSON(json: any): SleepScheduleRequest {
    return SleepScheduleRequestFromJSONTyped(json, false);
}

export function SleepScheduleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SleepScheduleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'regionId': json['region_id'],
        'totalDurationSeconds': json['total_duration_seconds'],
        'startTime': json['start_time'] == null ? undefined : (new Date(json['start_time'])),
        'sleepStartHour': json['sleep_start_hour'] == null ? undefined : json['sleep_start_hour'],
        'sleepEndHour': json['sleep_end_hour'] == null ? undefined : json['sleep_end_hour'],
        'varianceMinutes': json['variance_minutes'] == null ? undefined : json['variance_minutes'],
    };
}

export function SleepScheduleRequestToJSON(json: any): SleepScheduleRequest {
    return SleepScheduleRequestToJSONTyped(json, false);
}

export function SleepScheduleRequestToJSONTyped(value?: SleepScheduleRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'region_id': value['regionId'],
        'total_duration_seconds': value['totalDurationSeconds'],
        'start_time': value['startTime'] == null ? value['startTime'] : value['startTime'].toISOString(),
        'sleep_start_hour': value['sleepStartHour'],
        'sleep_end_hour': value['sleepEndHour'],
        'variance_minutes': value['varianceMinutes'],
    };
}

